import { render } from "./ExpensesListPage.vue?vue&type=template&id=53b6aaf2&ts=true"
import script from "./ExpensesListPage.vue?vue&type=script&lang=ts"
export * from "./ExpensesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__